(() => {
  'use strict';
  // Run before the theme's option handler submits the native localization form.
  // Keep only page context; never forward contact-success flags or tracking data.
  document.addEventListener('click', (event) => {
    const option = event.target.closest('[data-popout-option]');
    const form = option && option.closest('form');
    if (!form || !form.querySelector('input[name="language_code"]')) return;
    const input = form.querySelector('input[name="return_to"]');
    if (!input) return;
    const current = new URL(window.location.href);
    const target = new URL(input.value, current.origin);
    // A market-specific return path (including Hong Kong) takes precedence.
    if (target.origin !== current.origin || target.pathname !== current.pathname) return;
    const params = new URLSearchParams();
    ['view', 'page', 'variant', 'selling_plan'].forEach((key) => {
      const value = current.searchParams.get(key);
      const valid = key === 'view' ? /^[a-zA-Z0-9_-]+$/ : /^\d+$/;
      if (value && valid.test(value)) params.set(key, value);
    });
    // The unified product picker uses these values instead of variant alone.
    // Keep only recognized choices, never arbitrary query data.
    if (/\/products\//.test(current.pathname)) {
      const choices = {
        option: ['starter', 'refill', 'subscribe'],
        haro_tab: ['starter', 'pouches'],
        haro_subscribe: ['0', '1', 'true', 'false']
      };
      Object.entries(choices).forEach(([key, allowed]) => {
        const value = current.searchParams.get(key);
        if (allowed.includes(value)) params.set(key, value);
      });
    }
    target.search = params.toString();
    target.hash = current.hash;
    input.value = target.pathname + target.search + target.hash;
  }, true);
})();
